<template>
  <div v-if="resultado" class="row mt-3">
    <div v-if="resultado.data.length > 0" class="col-12">
      <div class="list-group">
        <div v-for="(diario, index) in resultado.data" :key="index"
             class="list-group-item flex-column align-items-start">
          <div class="d-flex w-100 justify-content-between">
            <h3 class="mb-1 mr-3 text-justify">{{ diario.pub_descricao }}</h3>
            <small class="text-muted">{{ diario.dia_downloads + ' downloads' }}</small>
          </div>
          <p class="mb-1">Diário Nª {{ diario.dia_numero | padDigits }}, {{
              diario.dia_data_publicacao |
                  dateExtensao
            }}</p>
          <a v-bind:href="baseUrl+'diario/publicacao/'+diario.pub_codigo" target="_blank"
             class="btn btn-outline-secondary btn-sm">Visualizar publicação</a>
          <router-link target="_blank" ref="link" class="btn btn-outline-secondary btn-sm"
                       :to="{name: 'diario', params: { dia_numero: diario.dia_numero }}">
            Diário em detalhe
          </router-link>
          <base-button outline type="secondary" @click="dowload(diario)" size="sm">Baixar PDF
          </base-button>
          <base-button outline type="secondary" @click="dowload(diario, 'HTML')" size="sm">Baixar HTML
          </base-button>
        </div>
      </div>
    </div>
    <div v-if="resultado.data.length < 1" class="col-md-12">
      Sua pesquisa não encontrou nenhuma publicação correspondente.
      <br>Sugestões:
      <ul class="ml-4">
        <li>Tente datas, textos, edições, seções ou títulos diferentes.</li>
        <li>Certifique-se de que o texto, edição ou título esteja escrito corretamente.</li>
      </ul>
    </div>
  </div>
</template>
<script>
import {getBaseURL} from "@/config"
import {dowloadDiario} from "@/plugins/webdom";

export default {
  name: 'secao-resultado',
  props: {
    resultado: {
      type: Object,
    }
  },
  data() {
    return {
      baseUrl: getBaseURL()
    }
  },
  methods: {
    dowload(diario, tipo = 'PDF') {
      dowloadDiario(diario, tipo)
    }
  },
  computed: {
    entidade() {
      return this.$store.getters.entidade;
    }
  }
}
</script>
<style>
</style>
